<template>
  <div class="recipe-view">
    <RecipeDetail
      v-if="recipe"
      :recipe="recipe"
      @back="goBack"
    />

    <div v-else class="not-found-state">
      <div class="not-found-icon">🔍</div>
      <h2>Receptet hittades inte</h2>
      <p>Vi kunde tyvärr inte hitta receptet du letade efter. Det kan ha tagits bort eller flyttats.</p>
      <button class="go-home-btn" @click="$router.push('/')">
        Gå till alla recept
      </button>
    </div>
  </div>
</template>

<script>
import RecipeDetail from '../components/RecipeDetail.vue'
import { getRecipeById } from '../data/recipes'
import { updateSEOForRecipe } from '../utils/seo'

export default {
  name: 'RecipeView',
  components: {
    RecipeDetail
  },
  computed: {
    recipeId() {
      return this.$route.params.id
    },
    recipe() {
      return getRecipeById(this.recipeId)
    }
  },
  watch: {
    recipe: {
      immediate: true,
      handler(newRecipe) {
        if (newRecipe) {
          updateSEOForRecipe(newRecipe)
        } else {
          document.title = 'Receptet hittades inte – Receptbanken'
          updateSEOForRecipe(null)
        }
      }
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.recipe-view {
  width: 100%;
}

.not-found-state {
  text-align: center;
  padding: 80px 20px;
  background-color: var(--color-card-bg);
  border-radius: var(--radius-md);
  border: 1px dashed var(--color-border);
  margin: 40px auto;
  max-width: 600px;
}

.not-found-icon {
  font-size: 3rem;
  margin-bottom: 12px;
}

.not-found-state h2 {
  font-size: 1.5rem;
  color: var(--color-text-main);
  margin-bottom: 8px;
}

.not-found-state p {
  color: var(--color-text-muted);
  margin-bottom: 24px;
}

.go-home-btn {
  background-color: var(--color-primary);
  color: #fff;
  padding: 10px 22px;
  border-radius: var(--radius-lg);
  font-weight: 600;
  font-size: 0.95rem;
}

.go-home-btn:hover {
  background-color: var(--color-primary-hover);
}
</style>
